import React from 'react';
import PropTypes from 'prop-types';
import escapeSpecialCharacters from '../util/escapeSpecialCharacters';

const FormattedTitle = ({ children: title, searchTerm }) => {
	if (searchTerm === '') {
		return <span>{title}</span>;
	} else {
		const term = escapeSpecialCharacters(searchTerm.trim());
		const search = new RegExp(term, 'gi');
		const matches = [];
		let match = search.exec(title);
		while (match !== null) {
			matches.push(match[0]);
			match = search.exec(title);
		}

		let keyCounter = -1;

		return (
			<span className="font-weight-bold">
				{title.split(search).reduce((prev, curr) => {
					keyCounter += 1;
					return [
						prev,
						<span key={keyCounter} className="font-weight-normal">
							{matches.shift()}
						</span>,
						curr
					];
				})}
			</span>
		);
	}
};
FormattedTitle.propTypes = {
	children: PropTypes.string.isRequired,
	searchTerm: PropTypes.string.isRequired
};
export default FormattedTitle;
